var React = require('react');

function Wave2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M672 24.5226V162.218C672 173.264 663.046 182.218 652 182.218H20C8.95431 182.218 0 173.264 0 162.218V0C46.4382 0.294138 115.219 1.81052 184 9.62798C218.133 13.5075 252.267 18.9388 286.4 24.3701C337.6 32.517 388.8 40.664 440 43.5736C517.333 47.9684 594.667 40.4149 672 24.5226Z"}));
}

Wave2.defaultProps = {"viewBox":"0 0 672 183","fill":"none"};

module.exports = Wave2;

Wave2.default = Wave2;
